"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderCompAndReturnUnmount = void 0;
var React = require("react");
var ReactDom = require("react-dom");
exports.renderCompAndReturnUnmount = function (elem, component, props) {
    ReactDom.render(React.createElement(component, props), elem);
    return function () {
        ReactDom.unmountComponentAtNode(elem);
    };
};
//# sourceMappingURL=render-comp-and-return-unmount.js.map